/*   1. G 端复用之前导航的配置方式
      1. 在 G 端的 root 节点增加选择导航还是分页模式
  2. C 端复用之前导航的逻辑
      1. 当前页面只有一组分页的时候，不需要展示分页组件
      2. 如果已经填完的页面可以快速切换页面，如果没有填过，不可以切换（？）
      3. 是否需要错误的浮动框，以及快速定位功能（？）
      4. 按照第一层的分组组件去分页
          1. 遍历所有第一层组件，找到所有页面，生成 tab 页条
          2. 把所有的页面和组件 id 的关系 cache 住，可以通过 page 找到 id，也可以通过 id 找到 page
          3. 页面的页数信息和数据信息可以缓存在 localstorge 中，在点击提交表单数据之后，清空 localStorge(?)
*/

import { get, isEmpty, isNil, intersection } from "lodash";

class StepManager {
  // page --> id
  __page__ = {
    pages: [],
    map: {},
  };

  // id -> page
  __id__ = {};

  // 当前所在页
  __currentPageIndex__ = 0;

  get current() {
    return this.__currentPageIndex__;
  }

  get pages() {
    return this.__page__.pages;
  }

  __travel__ = 0;

  __travel(val) {
    if (val > this.__travel__) {
      this.__travel__ = val;
    }
  }

  get travel() {
    return this.__travel__;
  }

  constructor({ fieldApi, context, schema, onChange }) {
    this.fieldApi = fieldApi;
    this.context = context;
    this.setSteps(schema);
    this.onChange = onChange
      ? onChange
      : (current) => {
        console.log(`当前是第${current}页`);
      };
  }

  setSteps(schema) {
    const __page__ = this.__page__;
    const recursiveGroups = (children, depths, pageId) => {
      children.forEach((child) => {
        if (!isEmpty(child.children)) {
          const fieldId = child.props.fieldId;
          let parentId;
          if (child.componentName === "GroupLayout" && depths === 0) {
            __page__.pages.push({
              id: fieldId,
              name:
                typeof child.props.title === "object"
                  ? child.props.title.zh_CN
                  : child.props.title,
            });
            parentId = fieldId;
          }

          const childIds = child.children.map((item) => {
            this.__id__[item.props.fieldId] = pageId || parentId;
            return item.props.fieldId;
          });

          if (pageId) {
            __page__.map[pageId] = (__page__.map[pageId] || []).concat(
              childIds
            );
          } else {
            __page__.map[fieldId] = (__page__.map[fieldId] || []).concat(
              childIds
            );
          }
          recursiveGroups(child.children, depths + 1, pageId || parentId);
        }
      });
    };

    // 在政务场景中，其实只需要取第一页的数据即可
    schema.pages.forEach((page) => {
      // 递归遍历 Group，但是要过滤掉外层的Group？
      recursiveGroups(page.layout.children, 0);
    });
  }

  has() { }

  getFieldIds() {
    const pageId = get(this, `__page__.pages[${this.__currentPageIndex__}].id`);
    return get(this, `__page__.map.${pageId}`, []);
  }

  getPageById(id) {
    return this.__id__[id];
  }

  go(index) {
    // 循环
    // 在第一页继续往前点，跳到最后一页
    // 在最后一页继续往前点，跳到第一页
    if (index < 0) {
      index = this.__page__.pages.length - 1;
    } else if (index > this.__page__.pages.length - 1) {
      index = 0;
    }
    this.__currentPageIndex__ = index;
    this.__travel(this.__currentPageIndex__);
    this.onChange(this.__currentPageIndex__);
  }

  goPage(code) {
    const index = this.__page__.pages.findIndex((item) => item.id === code);
    if (index > -1) this.go(index);
  }

  prev() {
    this.go(this.__currentPageIndex__ - 1);
  }

  next() {
    //TODO: 先校验，必须校验完，才能进入下一步
    this.go(this.__currentPageIndex__ + 1);
  }
}

export default StepManager;
